<template>
    <div class="col-sm-6 col-md-6 col-lg-4 p-3">
        <vue-card>
            <!-- <header slot="header">{{controller.alias}}</header> -->
            <div class="details">
                <div class="temp">
                    <vue-state :state="controller.state" />
                </div>
                <div class="right">
                    <div id="summary">{{controller.alias}}</div>
                    <div id="date">{{ timestamp }}</div>
                </div>
            </div>

            <!-- <form>
                <div class="form-row">
                    <div class="form-group col-md-6 col-lg-9">
                        <input type="number" class="form-control" v-model="controller.setpoint" />
                    </div>
                    <div class="form-group col-md-6 col-lg-3">
                        <button
                            class="btn btn-primary w-100"
                            @click="setSetpoint(controller.name, controller.setpoint)"
                        >Save</button>
                    </div>
                </div>
            </form>-->
            <footer slot="footer" class="small">
                {{$t('lastupdate')}}: {{ timestamp }}
                <a
                    class="float-right"
                    data-toggle="collapse"
                    :href="'#'+collapseName"
                    role="button"
                    aria-expanded="false"
                    :aria-controls="collapseName"
                >Show details</a>
                <div class="collapse" :id="collapseName">
                    <hr />
                    <pre>
                        <p class v-for="(item, name) in controller" :key="name">{{ name }}: {{item}}</p>
                    </pre>
                </div>
            </footer>
        </vue-card>
    </div>
</template>

<style scoped>
.danger {
    border: 1px solid red;
}

.details {
    top: 0;
    left: 0;
    right: 0;

    color: #888;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.details .right {
    text-align: right;
}

.details #date {
    margin: 4px 0;
}

.details #summary {
    font-weight: 600;
    font-size: 22px;
}

.details .temp {
    font-size: 60px;
    line-height: 60px;
}

.details .temp span {
    font-size: 18px;
    line-height: 30px;
    vertical-align: top;
}
</style>

<script>
import axios from "axios";
import moment from "moment";

export default {
    props: ["controller", "reading"],
    data() {
        return {
            quantity: 0,
            collapseName: "collapsePre" + this.controller.name,
        };
    },
    computed: {
        timestamp: function () {
            return moment(this.controller.timestamp).format(
                "dddd DD.MM.YYYY HH:mm"
            );
        },
    },

    created() {
        //const app = this;
        //if (app.controller.sensor) {
        //app.getSensorData(app.controller.sensor);
        //}
    },
    methods: {
        setSetpoint(controllerName, newSetPoint) {
            var date = {
                name: controllerName,
                setpoint: newSetPoint,
            };
            this.$emit("setSetpoint", date);
        },

        getSensorData() {
            const app = this;
            axios
                .get("/" + app.controller.sensor)
                .then((res) => {
                    app.reading = res.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>